import React, { useEffect, useState } from 'react';
import { Container, Typography, Alert, CircularProgress, Button, Box } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';

const FeaturedPaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const paymentId = searchParams.get('paymentId');
    
    // Backend callback már feldolgozta a fizetést
    // Csak UI feedback-et adunk
    setTimeout(() => {
      setSuccess(true);
      setLoading(false);
    }, 2000);
  }, [searchParams]);

  if (loading) {
    return (
      <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Fizetés feldolgozása...
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
      <CheckCircle sx={{ fontSize: 100, color: 'success.main', mb: 2 }} />
      <Typography variant="h4" gutterBottom>
        Sikeres fizetés!
      </Typography>
      <Alert severity="success" sx={{ mb: 3 }}>
        A kiemelt előfizetésed aktív! Profilod már kiemelt helyen jelenik meg a listázásban.
      </Alert>
      <Box>
        <Button
          variant="contained"
          onClick={() => navigate('/dashboard')}
          sx={{ mr: 2 }}
        >
          Dashboard
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate('/provider/featured')}
        >
          Előfizetések kezelése
        </Button>
      </Box>
    </Container>
  );
};

export default FeaturedPaymentSuccess;